/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { DataContextProvider } from '@forge/data-connector';
import { Card } from '@scuf/common';
import VirtualMeterEnergyUsageHOC from './VirtualMeterEnergyUsageHOC/VirtualMeterEnergyUsageHOC';
import './VirtualMeterEnergyUsageKPI.scss';
import { ContextProvider, updateApiConfig } from '../../context/ApiContext';
import IEnergyManagementProps from '../DashboardKPIWidgets/IEnergyManagementProps';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../locales/en-US/descriptors';
import { withLocalization } from '../../locales/withLocalization';

const VirtualMeterEnergyUsageKPI = (props: IEnergyManagementProps) => {
  const { connectorConfig, bearerToken, requestContext } = props;
  const [t] = useTranslation();
  const d = descriptors.energyManagement;
  return (
    <ContextProvider
      value={updateApiConfig({
        connectorConfig
      })}
    >
      <DataContextProvider config={connectorConfig}>
        <div className="emaas-VM-kpi-card">
          <Card className="VMCard">
            <Card.Header className="kpi-header-container">
              <div className="kpi-card-tab-VM">{t(d.ENERGYUSAGECAPS)}</div>
            </Card.Header>
            <Card.Content className="kpi-content-container">
              <VirtualMeterEnergyUsageHOC
                requestContext={requestContext}
                bearerToken={bearerToken}
              />
            </Card.Content>
          </Card>
        </div>
      </DataContextProvider>
    </ContextProvider>
  );
};

export default withLocalization<IEnergyManagementProps>(
  VirtualMeterEnergyUsageKPI
);
